export function formatTimeInSeconds(timeInSeconds: number) {
    if (timeInSeconds >= 60) {
        const minutes = Math.floor(timeInSeconds / 60)
        const seconds = timeInSeconds % 60
        return `${minutes} minute${minutes > 1 ? 's' : ''} et ${seconds} seconde${seconds > 1 ? 's' : ''}`
    } else {
        return `${timeInSeconds} seconde${timeInSeconds > 1 ? 's' : ''}`
    }
}
